import { Link } from 'react-router';
import { useMe } from '../lib/session';
import { CoinMascot } from '../components/Coin';
import { t } from '../i18n';

/** Phones: an empty state centred in the screen, with a full-width way home under the thumb. */
export function NotFound() {
  const { data: me } = useMe();
  return (
    <div className="mx-auto flex min-h-[min(560px,62dvh)] max-w-[560px] flex-col items-center justify-center py-10 text-center sm:min-h-0 sm:py-20">
      <div className="relative w-fit">
        <div className="display tabular-nums" aria-hidden="true">
          404
        </div>
        <CoinMascot
          size={64}
          rotate={-12}
          className="absolute -right-14 -top-6 h-14 w-14 sm:-right-16 sm:-top-5 sm:h-16 sm:w-16"
        />
      </div>
      <h1 className="large-title lg:heading mt-6">
        {
          // i18n: the 404 page: the address doesn't lead to any page of the site
          t('We couldn’t find that page.')
        }
      </h1>
      <p className="mx-auto mt-3 max-w-[40ch] text-pretty text-[16px] leading-relaxed text-graphite">
        {t(
          'The link may be old or mistyped. Your coins and everything else are right where you left them.',
        )}
      </p>
      {/* Signed in, go straight to the app's home instead of bouncing through the landing page. */}
      <Link
        to={me ? '/earn' : '/'}
        className="btn-primary mt-8 w-full max-w-[320px] py-3.5 text-[16px] active:scale-[0.98] sm:w-auto sm:py-3 sm:text-[15px]"
      >
        {me ? t('Back to earning') : t('Back to GaintPlay')}
      </Link>
    </div>
  );
}
